// src/app/services/tip.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipService {
  constructor(private http: HttpClient) { }

  getTips(source?: string): Observable<any> {
    let url = environment.restrictUserDomain + '/gettips/tips';
    if (source) {
      url += `?source=${encodeURIComponent(source)}`;
    }
    const token = localStorage.getItem('jwtToken') || '';
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.get<any>(url, { headers }).pipe(
      tap(res => console.log('[TipService] getTips() response:', res))
    );
  }

  uploadTipsImage(formData: FormData, type = 'web'): Observable<string> {
    const url = `${environment.restrictUserDomain}/upload/tips/${type}`;
    const token = localStorage.getItem('jwtToken') || '';
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http
      .request('POST', url, {
        body: formData,
        headers,
        responseType: 'text',
        observe: 'body'
      })
      .pipe(map(body => body as string));
  }

  updateTip(id: number, updatedTip: any): Observable<string> {
    const url = `${environment.restrictUserDomain}/tips/${id}`;
    const token = localStorage.getItem('jwtToken') || '';
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http
      .put<string>(url, updatedTip, {
        headers,
        responseType: 'text' as 'json'
      })
      .pipe(
        tap({
          next: res => console.log('[TipService] updateTip() response:', res),
          error: err => console.error('[TipService] updateTip() error:', err)
        })
      );
  }


  deleteTip(id: number): Observable<void> {
    const url = `${environment.restrictUserDomain}/tips/${id}`;
    const token = localStorage.getItem('jwtToken') || '';
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.delete<void>(url, { headers }).pipe(
      tap({
        next: () => console.log('[TipService] deleteTip() success'),
        error: err => console.error('[TipService] deleteTip() error:', err)
      })
    );
  }

}
